module.exports = __webpack_public_path__ + "static/media/kids_23.4040615c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_23.jpg
// module id = 5879
// module chunks = 0